import { IonContent, IonPage } from '@ionic/react';

const Dashboard = () => {
  return (
    <IonPage>
      <IonContent className="bg-gray-50">
        <div className="p-6">
          <h1 className="text-2xl font-bold">Dashboard</h1>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Dashboard;
